import AboutUs from "../assets/settings/AboutUS-new.svg";
import PrivacyPolicy from "../assets/settings/PrivacyPolicy.svg";
import UpdateInfo from "../assets/settings/CompanyNew.svg";
// import InvoiceInfo from "../assets/settings/InvoiceInfo.svg";
import Invoice from "../assets/settings/Invoice.svg";

export const settingsList = [
    {
        id: 1,
        name: 'updateInfo',
        icon: AboutUs,
        route: '/profile/settings/update-info',
    },
    {
        id: 2,
        name: 'invoices',
        icon: Invoice,
        route: '/profile/settings/invoice',
    },
    {
        id: 3,
        name: 'privacyPolicy',
        icon: PrivacyPolicy,
        route: '/profile/settings/privacy-policy',
    },
    {
        id: 4,
        name: 'myOrders',
        icon: UpdateInfo,
        route: '/profile/settings/my-orders',
    },
    // {
    //     id: 5,
    //     name: 'invoiceInfo',
    //     icon: InvoiceInfo,
    //     route: '/profile/settings/invoice-info',
    // }
];
